import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import { BodyM, Caption, HeadingS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React, { useState } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/addLineDialogStyle';
import { makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import QrCode from 'views/Numbers/Details/SimManagement/subcomponents/QrCode';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import SuccessBox from 'components/SuccessBox/SuccessBox';
import NumberInfo from 'views/Numbers/Details/common/NumberInfo';
import DialogTermsAndConditions from 'views/Numbers/Details/Services/subcomponents/common/DialogTermsAndConditions';
import apiConfig from 'utils/api/config';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IConfirmationProps {
	isOpen: boolean;
	hideDialog: () => void;
	selectedNumber: string | null;
	simDetails: types.newServices.ISimDetails | null;
}

const Confirmation = ({ hideDialog, selectedNumber, isOpen, simDetails }: IConfirmationProps) => {
	const classes = useStyles();

	const [loader, setLoader] = useState<boolean>(false);
	const [isChecked, setIsChecked] = useState<boolean>(false);

	const accept = () => {
		hideDialog();
	};

	return (
		<ConditionalRender
			show={!!simDetails}
			onFalse={() => (
				<CustomConfirmationDialog
					isOpen={isOpen}
					hideDialog={hideDialog}
					header={
						<>
							<BodyM>{translate('services.new.postpaid')}</BodyM>
							<HeadingS color="success">
								<>
									{translate('add.new.line.postpaid')}
									<br />
									{selectedNumber}
								</>
							</HeadingS>

							<div className={classes.confirmationEmail}>
								<Caption>{translate('add.new.line.confirmation.email')}</Caption>
							</div>
						</>
					}
				/>
			)}
			onTrue={() => (
				<CustomDialog
					isOpen={isOpen}
					hideDialog={hideDialog}
					header={translate('services.new.postpaid')}
					dialogBody={
						<div>
							<ConditionalRender
								show={!!simDetails?.qrCode}
								onTrue={() => (
									<div className={classes.successBoxWrapper}>
										<SuccessBox text={translate('services.new.postpaid.line.added')} />
									</div>
								)}
							/>
							<NumberInfo
								phoneNumber={selectedNumber ? selectedNumber : ''}
								accountDetails={translate('add.new.line.postpaid')}
							/>
							<ConditionalRender
								show={!!simDetails?.qrCode}
								onTrue={() => (
									<QrCode
										phoneNumber={selectedNumber ? selectedNumber : ''}
										setLoader={setLoader}
										esimQrData={{
											qrCode: simDetails ? simDetails.qrCode : '',
											qrLink: simDetails ? `${simDetails.url} ${simDetails.activationCode}` : '',
											serialNumber: simDetails ? simDetails.serialNumber : '',
										}}
										loader={loader}
										isEsim={true}
									/>
								)}
							/>
							<ConditionalRender
								show={!simDetails?.qrCode}
								onTrue={() => (
									<div className={classes.resultDataContainer}>
										<DialogTermsAndConditions
											termsAndConditions={{
												type: 'link',
												url: apiConfig.links.esimSupportedDevices,
												textUrl: 'numbers.esim.replacement.supported.devices',
												acceptText: 'numbers.esim.replacement.supported.devices.accept',
											}}
											isChecked={isChecked}
											setIsChecked={setIsChecked}
											showCheckbox
											showError={false}
										/>
									</div>
								)}
							/>
						</div>
					}
					rightSideButtons={
						simDetails
							? []
							: [
									{
										text: translate('cancel'),
										onClick: hideDialog,
										color: 'tertiary-light',
									},
									{
										text: translate('replace'),
										onClick: accept,
										color: 'primary-light',
										disabled: !isChecked,
									},
							  ]
					}
				/>
			)}
		/>
	);
};

export default Confirmation;
